import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {serviceTypeBasicInformationPropTypes} from '../proptypes/ServiceTypePropTypes';

const ServiceTypeBasicInformationResource = ({
  name, description
}) => (
  <>
    <ResourceProperty label="Nombre:">{name}</ResourceProperty>
    <ResourceProperty label="Descripción:">
      {description || '-'}
    </ResourceProperty>
  </>
);

ServiceTypeBasicInformationResource.propTypes = serviceTypeBasicInformationPropTypes;

export default ServiceTypeBasicInformationResource;
